module.exports = __webpack_public_path__ + "static/media/signage-indoor-img45.547bdaae.jpg";